import { render, staticRenderFns } from "./administratorCard.vue?vue&type=template&id=3f6c227f&scoped=true"
import script from "./administratorCard.vue?vue&type=script&lang=js"
export * from "./administratorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c227f",
  null
  
)

export default component.exports